import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class ProTipsService {

  constructor(private http : HttpClient) { }

  changeCoverImage(data): Observable<any> {
    const formData = new FormData();
    formData.append('file', data, data.name);
    return this.http.put<any>(urls.BASE_URL + urls.GET_NEMT_PRO_TIPS_URL, formData)
      .pipe(
        catchError(errorHandl)
      );

  }
}
